module.exports = __webpack_public_path__ + "img/01_Start-bg@2x.62f8dcd1.jpg";